<template>
  <div>
    <div class="page-title-block">
      <mtd-row class="page-head-block">
        <mtd-col :span="24" class="height-full">
          <span class="page-head-title">告警信息汇总</span>
        </mtd-col>
      </mtd-row>
      <mtd-row>
        <mtd-col :span="6" class="height-full">
          <mtd-form :model="query_params" :label-width="80">
            <mtd-form-item label="数据来源" class="margin-bottom-0">
              <mtd-select v-model="query_params.dataSource" style="width: 100%" @change="list_user_file" clearable>
                <mtd-option label="学城" value="km"/>
                <mtd-option label="大象" value="xm"/>
              </mtd-select>
            </mtd-form-item>
          </mtd-form>
        </mtd-col>
      </mtd-row>
    </div>
    <mtd-row class="page-content-block">
      <mtd-col :span="24">
        <mtd-table :data="alarm_list" size="small">
          <mtd-table-column prop="filename" label="文档名称" show-overflow-tooltip width="400">
            <template slot-scope="scope">
              <span v-if="scope.row.dataSource === 'xm'">{{ scope.row.filename }}</span>
              <span v-if="scope.row.dataSource === 'km'">
              <a :href="'https://km.sankuai.com/page/'+scope.row.filemd5" target="_blank">{{ scope.row.filename }}</a>
            </span>
            </template>
          </mtd-table-column>
          <mtd-table-column prop="secretLevel" label="密级"/>
          <mtd-table-column prop="viewUserCnt" label="数据来源">
            <template slot-scope="scope">
              <span v-if="scope.row.dataSource === 'xm'">大象</span>
              <span v-if="scope.row.dataSource === 'km'">学城</span>
            </template>
          </mtd-table-column>
          <mtd-table-column prop="viewUserCnt" label="查看人数">
            <template slot-scope="scope">
              {{ scope.row.viewUserCnt }}人
            </template>
          </mtd-table-column>
          <mtd-table-column prop="transferUserCnt" label="转发人数">
            <template slot-scope="scope">
              {{ scope.row.transferUserCnt }}人
            </template>
          </mtd-table-column>
          <mtd-table-column prop="downloadUserCnt" label="下载人数">
            <template slot-scope="scope">
              {{ scope.row.downloadUserCnt }}人
            </template>
          </mtd-table-column>
          <mtd-table-column prop="outputUserCnt" label="外发人数">
            <template slot-scope="scope">
              {{ scope.row.outputUserCnt }}人
            </template>
          </mtd-table-column>
          <mtd-table-column label="操作" width="90">
            <template slot-scope="scope">
              <mtd-button type="text" size="small" @click="show_detail(scope.row.id, scope.row.filename)"
                          style="color: #0a70f5;padding-left: 0">
                查看详情
              </mtd-button>
            </template>
          </mtd-table-column>
        </mtd-table>
        <div style="text-align: right;margin-top: 12px;">
          <mtd-pagination size="small" show-size-changer show-total :total="query_params.tn"
                          :page-size="query_params.sn" :current-page.sync="query_params.cn" @change="change_page"/>
        </div>
      </mtd-col>
    </mtd-row>
  </div>
</template>

<script>

import {mapActions} from 'vuex'

export default {
  name: "alert_index",
  data() {
    return {
      alarm_list: [],
      // 分页数据
      query_params: {
        dataSource: null,
        queryDt: null,
        misId: '',
        cn: 1, // 当前页面
        sn: 10, // 每页大小
        tn: 0 // 总条数
      },
    }
  },
  computed: {},
  mounted: function () {
    let query_params = this.$route.query;
    if (query_params) {
      let {dataSource, dt} = query_params;
      if (dataSource === 'xm' || dataSource === 'km') {
        this.query_params.dataSource = dataSource;
      }
      if (dt && (/^\d{8}$/.test(dt))) {
        this.query_params.queryDt = dt;
      }
    }
    this.list_user_file();
  },
  methods: {
    // API方法
    ...mapActions({
      api_list_file: 'api_file_trace_query_file',
    }),
    list_user_file() {
      this.query_params.size = this.query_params.sn;
      this.query_params.page = this.query_params.cn;
      this.api_list_file(this.query_params).then((res) => {
        if (res.code === 0) {
          let {cn, sn, tn, items} = res.data;
          this.alarm_list = items;
          this.query_params.cn = cn;
          this.query_params.sn = sn;
          this.query_params.tn = tn;
        } else {
          this.$mtd.message.error('获取数据失败');
        }
      });
    },
    change_page(current, size) {
      this.query_params.cn = current;
      this.query_params.sn = size;
      this.list_user_file()
    },
    show_detail(id, filename) {
      this.$router.push({
        name: "file_alert_detail",
        params: {file_id: id, filename, dataSource: this.query_params.dataSource, queryDt: this.query_params.queryDt}
      });
    },
  }
}
</script>

<style scoped>

@import "../../../styles/public.css";
@import "../../../styles/reset_table.css";

.page-head-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0.5px;
  line-height: 28px;
}
</style>
